import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { Button, Dialog, DialogTitle, Grid, Toolbar, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import { ValidatorForm } from "react-material-ui-form-validator";
import { BuscadorUsuarioOspe } from './BuscadorUsuarioOspe';
import { agregarEquivalenciaNroMedicoOspe } from '../../../../actions/turnos/efectorHorarios';

const useStyles = makeStyles((theme) => ({
    root:{
        marginLeft: "auto",
        marginRight: "auto",
        width: "74%",
    },
    header:{
        background: '#68389F',
        color:'white'
      },
    botonera: {
        marginTop: 50,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
}));

export const ModalEquilvalenciaOspe = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, setOpen, title, idProfesional, idCentroMedico, idEspecialidad } = props;
    const [ usuarioSel, setUsuarioSel ] = useState();

    const handleSave = () => {
        dispatch( agregarEquivalenciaNroMedicoOspe(idProfesional, idCentroMedico, idEspecialidad, usuarioSel.nroMedicoOspe, closeModal, props.doNuevoRegistro) );
    }

    const closeModal = () => {
        setOpen(false);
        setUsuarioSel();
    }
    
    return (
        <Dialog
            maxWidth="md"
            fullWidth={true}
            open={open}
            onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <ValidatorForm onSubmit={handleSave}>
                <div className={classes.root}>
                    <Grid container >
                        <Grid item xs={12}>
                            <h3>No se encontro un usuario cargado para visualizar los turnos en HCE, debe seleccionar uno para poder continuar.</h3>
                        </Grid>
                        <Grid item xs={12} md={10} >
                            <BuscadorUsuarioOspe 
                                setUsuarioSel={setUsuarioSel}
                                doNuevoRegistro={props.doNuevoRegistro} 
                            />
                        </Grid>
                        <Grid item xs={4} >
                        </Grid>
                    </Grid>
                        
                    <Grid className={classes.botonera} container >
                        <Grid item xs={10}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<CancelIcon />}
                                    onClick={closeModal}
                                >
                                    CANCELAR
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    disabled={!usuarioSel}
                                    startIcon={<SaveIcon />}
                                    // type="submit"
                                    onClick={handleSave}
                                >
                                    CONFIRMAR
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </ValidatorForm>
        </Dialog>
    );

};
